export type LanguageStatus =
  | "up_to_date"
  | "outdated"
  | "needs_attention"
  | "not_added";
export interface ReferenceIssue {
  row_index?: number | null;
  node_id?: string | null;
  node_index?: number;
  index?: number;
  code?: string | null;
  reason?: string;
  detail?: string;
}
export interface LanguageState {
  language: string;
  status?: LanguageStatus;
  version_id?: string | null;
  source_version_id?: string | null;
  has_manual_changes?: boolean;
  attention_reasons?: string[];
  reference_issues?: ReferenceIssue[];
}
export interface LanguageVersion extends LanguageState {
  head_id: string;
  latest_version: number;
  updated_at: string;
  latest_text?: string;
}
export interface ProductRecord {
  id: string;
  name: string;
  sku?: string | null;
  ean?: string | null;
  base_language: string;
  updated_at?: string;
  search_matches?: { language: string; code?: string | null; text: string }[];
  translation_languages?: string[];
  language_states?: LanguageState[];
  website_enabled?: boolean;
  ghs_pictograms?: string[];
  sds?: {
    file_id: string;
    original_filename: string;
    attached_at?: string;
  } | null;
}
export interface WebsiteRecord {
  enabled: boolean;
  public_key?: string;
  embed_path?: string;
  updated_at?: string;
}
export interface HistoryVersion {
  id: string;
  version: number;
  text?: string;
  created_at: string;
  created_by: string;
}
export interface BatchResult {
  product_id: string;
  product_name: string;
  status: string;
  skip_reason?: string;
  error_code?: string;
  error_detail?: string;
}

export function languageStatus(
  version?: LanguageState,
  hasSource = true,
): LanguageStatus {
  if (!version) return "not_added";
  if (
    !hasSource ||
    version.reference_issues?.length ||
    version.attention_reasons?.length
  )
    return "needs_attention";
  return version.status || "needs_attention";
}
export function languageName(code: string, locale = "en"): string {
  try {
    return (
      new Intl.DisplayNames([locale], { type: "language" }).of(code) ||
      code.toUpperCase()
    );
  } catch {
    return code.toUpperCase();
  }
}
export function generationEligible(
  product: ProductRecord,
  target: string,
): boolean {
  const langs =
    product.translation_languages ||
    product.language_states?.map((x) => x.language) ||
    [];
  const source = product.language_states?.find(
    (x) => x.language === product.base_language,
  );
  return (
    !!target &&
    target !== product.base_language &&
    langs.includes(product.base_language) &&
    !langs.includes(target) &&
    !!source &&
    source.status === "up_to_date" &&
    !source.attention_reasons?.length &&
    !source.reference_issues?.length
  );
}
